export default __webpack_public_path__ + "static/media/register_calendar.bb34fe41.svg";